/* eslint-disable no-useless-constructor */
import TextField from './TextField';
import { verifyEmail, verifyLink } from '../../../../juristec-ui/utils/validators/inputTextValidators';

class UrlField extends TextField {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {boolean} [params.email] Marks if input is for email
   */
  constructor(params) {
    super(params);
  }

  handleInput = (e, handle) => {
    const val = e.target.value.trim();
    const msg = this.email ? verifyEmail(val) : verifyLink(val);
    handle({
      [this.kWord]: {
        value: val,
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  }

  handleBlurTrim = () => {};
}

export default UrlField;
